import { useEffect } from "react"
import { Controller, useForm } from "react-hook-form";
import InvalidFeedback from "../../components/InvalidFeedback"
import ReactSelect from 'react-select';



function FormValidatorsPartial({ data, onClose }) {

    const PAYLOAD_VARIABLES = [
        { value: 'message', label: 'message' },
        { value: 'phone_number', label: 'phone_number' },
        { value: 'name', label: 'name' },
        { value: 'ticket_id', label: 'ticket_id' },
        { value: 'bot_id', label: 'bot_id' },
    ];
    
    const expressionToURL = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})|(http:\/\/localhost)./gi;
    
    const defaultValues = {
        internalID: '',
        type: '',
        message: { es: '' },
        show_messages_again: false,
        config: {
            pattern: '',
            webhook: {
                url_dev: '',
                url_prod: '',
                payload: []
            }
        }
    }

    const { control, register, unregister, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const type = watch('type');

    const addValidator = (data: any) => {
        if(type === 'PATTERN') {
            delete data.config.webhook
        }
        if(type === 'WEBHOOK') {
            delete data.config.pattern
        }

        onClose(data)
    }

    useEffect(() => {
        switch (type) {
            case 'PATTERN':
                setValue('config.webhook', {
                    url_dev: '',
                    url_prod: '',
                    payload: []
                })
                break;
            case 'WEBHOOK':
                setValue('config.pattern', '')
                break;

            default:
                break;
        }
    }, [type])

    useEffect(() => {
        if(data) {
            reset(Object.assign(defaultValues, data ))
        } else {
            reset(defaultValues)
        }
        
    }, [data])


    return (
        <div className='push-view view-node show'>
            <div className="card-header  d-flex align-items-center">
                <button type="button" className="btn btn-ghost-light btn-icon ml-negative-1" style={{ height: 'auto' }} onClick={() => onClose()}>
                    <i className="bi-chevron-left text-dark"></i>
                </button>
                <h3 className="card-header-title">Agregar validación</h3>
            </div>

            <div className="card-body">

                <div className="mb-3">
                    <label className="form-label" >Tipo de validación *</label>
                    <select className={'form-control ' + (errors?.type ? 'is-invalid' : '')}  {...register('type', { required: true })}>
                        <option disabled value={''}>Elija una opción</option>
                        <option value={'NOT_MATCH_MENU'}>Sin coincidencias</option>
                        <option value={'EMAIL'}>Correo electrónico</option>
                        <option value={'NUMBER'}>Número</option>
                        <option value={'DATE'}>Fecha</option>
                        <option value={'URL'}>URL</option>
                        <option value={'PATTERN'}>Expresión regular</option>
                        <option value={'WEBHOOK'}>WebHook</option>
                        {/* <option value={'CUSTOM'}>Personalizado</option> */}
                    </select>
                    <InvalidFeedback error={errors.type} />
                </div>

                {
                    type === 'PATTERN' && (
                        <div className="mb-3">
                            <label className="form-label">Regex *</label>
                            <input type="text" className={'form-control ' + (errors.config?.pattern ? 'is-invalid' : '')} placeholder="pattern" {...register('config.pattern', { required: true })} />
                            <InvalidFeedback error={errors.config?.pattern} />
                        </div>
                    )
                }

                {
                    type === 'WEBHOOK' && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">URL desarrollo *</label>
                                <input type="text" className={'form-control ' + (errors?.config?.webhook?.url_dev ? 'is-invalid' : '')} {...register('config.webhook.url_dev', { required: true, pattern: { value: new RegExp(expressionToURL), message: 'Debe ingresar una URL válida' } })} />
                                <InvalidFeedback error={errors?.config?.webhook?.url_dev} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">URL producción *</label>
                                <input type="text" className={'form-control ' + (errors?.config?.webhook?.url_prod ? 'is-invalid' : '')} {...register('config.webhook.url_prod', { required: true, pattern: { value: new RegExp(expressionToURL), message: 'Debe ingresar una URL válida' } })} />
                                <InvalidFeedback error={errors?.config?.webhook?.url_prod} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label" >Payload *</label>
                                <Controller
                                    control={control}
                                    name='config.webhook.payload'
                                    rules={{ required: true, min: 1 }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <ReactSelect
                                            placeholder={'Seleccionas variables'}
                                            isMulti
                                            options={PAYLOAD_VARIABLES}
                                            classNamePrefix="react-select"
                                            isClearable={false}
                                            className={'react-select-creatable ' + (error ? 'is-invalid' : '')}
                                            onChange={(value: any) => onChange(value.map((v: any) => v.value))}
                                            value={value.map(v => ({ label: v, value: v }))}
                                        />
                                    )}
                                />
                                <InvalidFeedback error={errors.config?.webhook?.payload} />
                            </div>
                        </>
                    )
                }

                <div className="mb-3">
                    <label className="form-label" >Feedback *</label>
                    <textarea className={'form-control ' + (errors.message?.es ? 'is-invalid' : '')} placeholder="Mensaje" rows={4} {...register('message.es', { required: true, maxLength: { value: 1024, message: '1024' } })}></textarea>

                    <InvalidFeedback error={errors.message?.es} />
                    <div className="form-text mt-1 text-end">{watch('message.es').length}/1024</div>
                </div>

                <div className="form-check mb-3">
                    <input type="checkbox" id="show_messages_again" className="form-check-input" {...register('show_messages_again')} />
                    <label className="form-check-label" htmlFor="show_messages_again">Mostrar mensajes de este bloque tras un error de validación</label>
                </div>

                <div className="d-grid gap-2 mt-5  mb-3 ">
                    <button type="button" className="btn btn-primary" onClick={handleSubmit(addValidator)} disabled={!isValid}>Guardar</button>
                </div>

            </div>
        </div>
    )
}
export default FormValidatorsPartial